import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import StepButton from "components/views/StepButton";
import T from "i18n";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.spacer}px;
`;

const YesNo = ({ className, onYes, onNo }) => {
  const classes = ["YesNo"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      <StepButton label={(<T path="button.yes" />)} onClick={onYes} />
      <StepButton label={(<T path="button.no" />)} onClick={onNo} />
    </Wrapper>
  );
};

YesNo.displayName = "YesNo";

YesNo.propTypes = {
  className: PropTypes.string,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired,
};

YesNo.defaultProps = {
  className: null,
};

export default YesNo;
